"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._testHook = void 0;

require("whatwg-fetch");

// By default, we will use this endpoint on the PRE to access saved and claimed home data
var DEFAULT_SAVED_SEARCHES_ENDPOINT = '/personalization/api/SavedSearches.htm';

function convertServerResponseJSONToFetcherResponse(serverResponseJson) {
  if (!serverResponseJson.error) {
    var SavedSearchesResults = [];

    if (serverResponseJson.savedsearches) {
      SavedSearchesResults = serverResponseJson.savedsearches.map(function (savedSearch) {
        return {
          category: 'SAVED_SEARCH',
          displayName: savedSearch.name,
          url: savedSearch.url,
          notificationCount: savedSearch.notificationCount
        };
      });
    }

    return SavedSearchesResults;
  }

  return [];
}

var SavedSearchFetcher = /*#__PURE__*/function () {
  // constructor
  // argument: urlOverride - a String containing an alternat URL to fetch saved/claimed homes from
  function SavedSearchFetcher(urlOverride) {
    this.baseURL = urlOverride || DEFAULT_SAVED_SEARCHES_ENDPOINT;
  } // fetchResults
  // returns a Promise that resolves to an array of autocomplete entries


  var _proto = SavedSearchFetcher.prototype;

  _proto.fetchResults = function fetchResults() {
    var fetchOptions = {
      credentials: 'include' // we need to send cookie state for login

    };
    var returnPromise = fetch(this.baseURL, fetchOptions).then(function (response) {
      return response.json();
    }).then(function (json) {
      return convertServerResponseJSONToFetcherResponse(json);
    }).catch(function () {
      return [];
    });
    return returnPromise;
  };

  return SavedSearchFetcher;
}();

var _testHook = {
  convertServerResponseJSONToFetcherResponse: convertServerResponseJSONToFetcherResponse
};
exports._testHook = _testHook;
var _default = SavedSearchFetcher;
exports.default = _default;